module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHg9IjAuNTAxNDY1IiB5PSIwLjUiIHdpZHRoPSIyNiIgaGVpZ2h0PSIyLjUiIHJ4PSIxIiBmaWxsPSIjRjZEOUFBIi8+DQo8cmVjdCB4PSIwLjUwMTQ2NSIgeT0iNy41NDY4OCIgd2lkdGg9IjI2IiBoZWlnaHQ9IjIuNSIgcng9IjEiIGZpbGw9IiNGNkQ5QUEiLz4NCjxyZWN0IHg9IjAuNTAxNDY1IiB5PSIxNC41OTM4IiB3aWR0aD0iMjYiIGhlaWdodD0iMi41IiByeD0iMSIgZmlsbD0iI0Y2RDlBQSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/Menu.svg
// module id = NLYM
// module chunks = 0